import { Link } from '@tanstack/react-router';
import Menu from 'lucide-react/dist/esm/icons/menu';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { getNavItems } from '@/lib/nav-items';

export function MobileNav() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" className="me-2 px-2 md:hidden">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Menu</span>
        </Button>
      </SheetTrigger>

      <SheetContent side="right" className="w-64">
        <SheetHeader>
          <SheetTitle>Pricedrop</SheetTitle>
        </SheetHeader>
        <div className="grid gap-2 py-4">
          {getNavItems().map((item) => (
            <SheetClose key={item.href} asChild>
              <Button variant="ghost" className="justify-start" asChild>
                <Link to={item.href}>{item.title}</Link>
              </Button>
            </SheetClose>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
